import React from 'react';

const Loading: React.FC = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
    <div style={styles.spinner} />
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  spinner: {
    width: 40, height: 40,
    border: '3px solid #ece3f7',
    borderTopColor: '#b39ddb',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};

// inject keyframes
const styleEl = document.createElement('style');
styleEl.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
document.head.appendChild(styleEl);

export default Loading;
